import { Loader, TextNew } from '@jfs/ui-new'
import React from 'react'

interface LoaderOrText {
  state: 'pending' | 'fulfilled' | 'rejected' | undefined
  text: string
}

export const LoaderOrText = ({ state, text }: LoaderOrText) => {
  if (state === 'pending') {
    return <Loader color="WHITE" />
  } else {
    return (
      <TextNew color={'WHITE'} fontFamily="jiotype-medium" fontSize={14}>
        {text ?? 'Press'}
      </TextNew>
    )
  }
}
